import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import {
  LayoutDashboard,
  PlusCircle,
  List,
  Barcode,
  Package,
  LogOut,
} from "lucide-react";
import "./SellerLayout.css";


const SellerLayout = ({ children }) => {
  const navigate = useNavigate();

  const sidebarLinks = [
    { name: "Dashboard", href: "/sellerDashboard", icon: <LayoutDashboard size={18} /> },
    { name: "Add Product", href: "/selleraddproduct", icon: <PlusCircle size={18} /> },
    { name: "Product List", href: "/SellerProductList", icon: <List size={18} /> },
    { name: "Barcode List", href: "/barcodeScanner", icon: <Barcode size={18} /> },
    { name: "Seller Orders", href: "/sellerOrder", icon: <Package size={18} /> },
    { name: "Billing", href: "/seller/billing", icon: <LayoutDashboard size={18} />  },
  ];

const logout = async () => {
  try {
    await axios.get(`${process.env.REACT_APP_API_URL}/api/seller/logout`, {
      withCredentials: true,
    });

    // Clear all client-side storage
    localStorage.clear();
    sessionStorage.clear();

    // Replace current page in history to prevent back navigation
    window.history.replaceState(null, "", "/");

    // Navigate and reload to clear any cached seller data
    navigate("/", { replace: true });
    window.location.reload();
  } catch (err) {
    console.error("Logout failed:", err);
    navigate("/", { replace: true });
  }
};






  return (
    <div className="seller-dashboard">
      {/* Sidebar */}
      <aside className="seller-sidebar">
        <div className="sidebar-header">
          <h2 className="text-white">🛒 Grocery Seller</h2>
          <p>Seller Panel</p>
        </div>
        <ul className="sidebar-links">
          {sidebarLinks.map((link, index) => (
            <li key={index}>
              <NavLink
                to={link.href}
                className={({ isActive }) =>
                  isActive ? "active sidebar-link" : "sidebar-link"
                }
              >
                {link.icon}
                <span>{link.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </aside>

      {/* Main Area */}
      <div className="seller-main">
        <header className="seller-header">
          <h3>Welcome, Seller</h3>
          <button className="logout-btn" onClick={logout}>
            <LogOut size={18} /> Logout
          </button>
        </header>

        <main className="seller-content">{children}</main>
      </div>
    </div>
  );
};

export default SellerLayout;
